import { debounce } from 'lodash-es'
import LastUpdateInfo from '@/features/updateModal/index.vue'
import { useEmptyModal } from '~/hooks/useModal/modals/empty'
import { type ProjectLogItem } from '~/api/interface/auth'

export const showUpdateLog = debounce((data: ProjectLogItem[], url: string) => {
  const cancel = () => {
    modal.destroy()
  }

  const modal = useEmptyModal({
    width: 607,
    closable: false,
    content: <LastUpdateInfo cancel={cancel} data={data} link={url} />,
    wrapClassName: 'xmov-empty-modal xmov-update-info-modal',
  })

  return modal
}, 200)
